import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/san-pham/[id]/ProductDetailClient.tsx");
